import * as React from "react";
import { CircleQuestionMark } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
const faqData = [{
  question: "תוך כמה זמן מגיע מטפל סיעודי לבית המטופל?",
  answer: "אנו מתחייבים למציאת פתרון והגעת מטפל מקצועי תוך 5 שעות מרגע הפנייה. המוקד שלנו פועל מסביב לשעון כדי להבטיח מענה מיידי במצבי חירום או שחרור מבית חולים."
}, {
  question: "האם המטפלים שלכם עוברים הכשרה מקצועית?",
  answer: "בהחלט. כל המטפלים בצוות שלנו עוברים סינון קפדני, בדיקת המלצות והכשרה ייעודית לטיפול סיעודי בבית. אנו מוודאים התאמה מלאה בין צרכי המטופל לניסיון המטפל."
}, {
  question: "מה קורה אם המטפל אינו מתאים למטופל?",
  answer: "הרווחה שלכם היא בראש סדר העדיפויות שלנו. במידה ואין כימיה או התאמה, אנו נדאג להחלפת המטפל באופן מיידי וללא עלות נוספת, עד למציאת המענה המושלם עבורכם."
}, {
  question: "האם השירות ניתן גם בסופי שבוע וחגים?",
  answer: "כן, השירות שלנו זמין 24/7, כולל שבתות וחגים. אנו מבינים שצרכים סיעודיים אינם מחכים, ולכן המערך המבצעי שלנו ערוך לתת מענה בכל יום ובכל שעה."
}, {
  question: "באילו ערים ניתן לקבל את השירות המהיר?",
  answer: "אנו מספקים שירות בפריסה ארצית רחבה, כולל תל אביב, ירושלים, חיפה, פתח תקווה, נתניה, ראשון לציון וערים רבות נוספות. ניתן לבדוק זמינות ספציפית במוקד הטלפוני."
}, {
  question: "האם אתם מסייעים גם בהתנהלות מול הביטוח הלאומי?",
  answer: "הצוות המקצועי שלנו מעניק ייעוץ ראשוני והכוונה בנוגע למיצוי זכויות סיעוד, עבודה עם חברות ביטוח והגשת תביעות לביטוח הלאומי כדי להקל עליכם את התהליך הבירוקרטי."
}, {
  question: "מהן אפשרויות התשלום עבור השירות?",
  answer: "אנו מציעים מסלולי תשלום גמישים המותאמים לצרכי המשפחה, כולל אפשרות למימון פרטי, שימוש בגמלת סיעוד או החזרים מביטוחי בריאות פרטיים."
}];
export default function FrequentlyAskedQuestions() {
  return <section data-section-id="261058" id="שאלות-נפוצות" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center mb-12 flex flex-col items-center">
          <Badge variant="secondary" className="mb-4 bg-accent text-accent-foreground hover:bg-accent/80 border-none rounded-md">
            <CircleQuestionMark className="w-4 h-4 ml-1 text-primary" />
            שאלות ותשובות נפוצות
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-primary font-default mb-4">
            כל מה שחשוב לדעת על שירותי הסיעוד שלנו
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            ריכזנו עבורכם את התשובות לשאלות הנפוצות ביותר כדי שתוכלו לקבל החלטה מושכלת ומהירה עבור יקיריכם.
          </p>
        </div>

        <Card className="shadow-lg border-border bg-card rounded-lg">
          <CardContent className="p-6 md:p-8">
            <Accordion type="single" collapsible className="w-full">
              {faqData.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border last:border-0">
                  <AccordionTrigger className="text-primary font-default text-right text-base md:text-lg hover:text-secondary transition-colors py-5">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground leading-relaxed text-base pb-6 font-default">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </CardContent>
        </Card>
      </div>
    </section>;
}